import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getVersion: builder.query({
      query: () => {
        return {
          url: `/version`,
          method: "GET",
        };
      },
      transformResponse: (res) => res.version,
    }),
  }),
});

export const { useGetVersionQuery } = appApi;
